define.alias("shared/components/shared/ui/banner", "calendar/components/shared/ui/banner");